import React from 'react';
import { MapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { images } from '../data/offer';
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-14 pt-8 sm:pb-20 sm:pt-12" data-id="element-170" data-mp="9k0eb6ruedp4">
      <div className="mx-auto max-w-5xl text-center" data-id="element-171" data-mp="4lql31pohn65">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-172" data-mp="4n9z0lnv3m4r">
          <span className="flex items-center gap-2" data-id="element-173" data-mp="128frdnreylxt">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand text-white" data-id="element-174" data-mp="1274mtlq59a5n">
              <MapIcon className="h-5 w-5" aria-hidden="true" data-id="element-175" data-mp="sbb2hg66ocdb" />
            </span>
            <span className="font-serif text-xl font-black text-brand-dark" data-id="element-176" data-mp="sde30u4ypnwa">Perio Blueprint™</span>
          </span>
          <span className="rounded-full border border-brand/15 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-brand" data-id="element-177" data-mp="nekqb3xi20x6">
            The Periodontal Clinical Roadmap
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl text-balance font-serif text-[38px] font-black leading-[1.05] text-ink sm:text-6xl lg:text-7xl" data-id="element-178" data-mp="3j8sgk46tfprf">
          Organize Your Periodontal Case Review in{' '}
          <em className="italic text-brand" data-id="element-179" data-mp="39al7s8moke0i">15&nbsp;Minutes</em>
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-balance font-serif text-xl font-bold italic text-gum sm:text-2xl" data-id="element-180" data-mp="39cpain8uf6z7">
          With a clear, step-by-step clinical framework
        </p>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-xl" data-id="element-181" data-mp="30fy7fqvvirv4">
          A practical visual system designed to help you organize periodontal findings, connect essential concepts,
          identify missing information, and structure your case analysis with greater clarity. Includes{' '}
          <strong className="text-ink" data-id="element-182" data-mp="2hj5clq725iyo">6 Premium Volumes</strong>, <strong className="text-ink" data-id="element-183" data-mp="2hjoz7k7nkvj1">5 Professional Bonuses</strong>,
          Clinical Assessment Maps, Case Analysis Worksheets, and Reusable Checklists.
        </p>

        <img src={images.mockup} alt="Perio Blueprint™ — six volumes, worksheets, tablet edition and five bonus books" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-184" data-mp="s2b7hx6yyh4m" />

        <div className="mt-4" data-id="element-185" data-mp="ibgor2sxlznx">
          <CTAButton id="hero-cta" label="Get the Perio Blueprint™" subline="Instant Digital Access · One-Time Payment of $27 USD · Lifetime Access to Purchased Materials · 7-Day Guarantee" data-id="element-186" data-mp="ichxv1qe0c30" />
        </div>

        <Countdown data-id="element-187" data-mp="161ayvclv9a4h" />

        <div className="mx-auto mt-6 max-w-md rounded-2xl bg-white px-5 py-4 ring-1 ring-brand/10" data-id="element-188" data-mp="162ufj4bfpn6s">
          <p className="font-bold text-ink" data-id="element-189" data-mp="111ohcqz097pv">
            Special Launch Offer — <span className="text-cta" data-id="element-190" data-mp="x1ecjhmy8ncl">$27 USD</span>
          </p>
          <p className="mt-1 text-sm text-muted" data-id="element-191" data-mp="x37am8jhxz8z">Your currency is automatically converted at checkout, where supported.</p>
        </div>
      </div>
    </header>;
}